import { render, staticRenderFns } from "./QuizPage.vue?vue&type=template&id=7f2a0bbc&scoped=true"
import script from "./QuizPage.vue?vue&type=script&lang=js"
export * from "./QuizPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a0bbc",
  null
  
)

export default component.exports